const pageNameKey = "checkedUnorderedList";

export const checkedUnorderedListEn = {
  [pageNameKey]: {
    checkedCircleAltText: "Checked Circle",
  },
};

export const checkedUnorderedListPtBr = {
  [pageNameKey]: {
    checkedCircleAltText: "Círculo marcado",
  },
};

export const checkedUnorderedListDe = {
  [pageNameKey]: {
    checkedCircleAltText: "Abgehakter Kreis",
  },
};

export const checkedUnorderedListZhHans = {
  [pageNameKey]: {
    checkedCircleAltText: "已选圆圈",
  },
};

export const checkedUnorderedListIt = {
  [pageNameKey]: {
    checkedCircleAltText: "Cerchio con spunta",
  },
};

export const checkedUnorderedListEs = {
  [pageNameKey]: {
    checkedCircleAltText: "Círculo marcado",
  },
};

export const checkedUnorderedListNl = {
  [pageNameKey]: {
    checkedCircleAltText: "Cirkel met vinkje",
  },
};

export const checkedUnorderedListTr = {
  [pageNameKey]: {
    checkedCircleAltText: "İşaretli Daire",
  },
};
